import { render, staticRenderFns } from "./CurrencyModal.vue?vue&type=template&id=07b455ed"
import script from "./CurrencyModal.vue?vue&type=script&lang=js"
export * from "./CurrencyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports